<template>
    <div class="economy-learning-materials">
        <div class="row">
            <div class="col-lg-6">
                <material-usage />
            </div>
            <div class="col-lg-6">
                <suppliers />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {
        'material-usage': require('../components/materialUsage'),
        'suppliers': require('../components/suppliers')
    }
}
</script>



// WEBPACK FOOTER //
// materials.vue?052456e6